<template>
  <div class="w-full flex flex-wrap justify-content-center gap-2 mt-2">
    <NuxtLink
      v-for="link in web_links"
      :key="link.id || link.url"
      :to="getWebLink(link)"
      :target="isExternal(link.url) ? '_blank' : undefined"
      :rel="isExternal(link.url) ? 'noopener noreferrer' : undefined"
    >
      <Button rounded :label="link.name" class="border-none" />
    </NuxtLink>
  </div>
</template>

<script setup>
import { isExternal } from '~/composables/useUtils'

const props = defineProps(['web_links'])

const getWebLink = (link) => {
  return link.query_field && link.query_value
    ? `${link.url}?${link.query_field}=${link.query_value}`
    : link.url
}
</script>
